import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import webDevelopment from "../assets/img/web_development.svg";
import systems from "../assets/img/systems.svg";
import dataAnalysis from "../assets/img/data_analysis.svg";
import ai from "../assets/img/ai.svg";
import machineLearning from "../assets/img/machine_learning.svg";
import 'animate.css';

export const Skills = ({ onLoad }) =>{
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };
    
    return(
        <section className="skill" id="skills" >
            <Container>
                <Row>
                    <Col>
                        <div className="skill-bx">
                            <h2>Skills</h2>
                            <p>Competencias</p>
                            <Carousel responsive={responsive} infinite={true} className="skill-slider">
                                <div className="item">
                                    <img onLoad={ onLoad } src={webDevelopment} alt="Desarrollo Web"></img>
                                    <h5>Desarrollo </h5>
                                    <h5>Web</h5>
                                </div>
                                <div className="item">
                                    <img onLoad={ onLoad } src={systems} alt="Soluciones de Sistemas"></img>
                                    <h5>Soluciones de Sistemas</h5>
                                </div>
                                <div className="item">
                                    <img onLoad={ onLoad } src={machineLearning} alt="Desarrollo de Modelos AI"></img>
                                    <h5>Desarrollo de Modelos AI</h5>
                                </div>
                                <div className="item">
                                    <img onLoad={ onLoad }src={dataAnalysis} alt="Análisis de Datos"></img>
                                    <h5>Análisis de Datos</h5>
                                </div>
                                <div className="item">
                                    <img onLoad={ onLoad } src={ai} alt="Visualización de datos"></img>
                                    <h5>Visualización de datos</h5>
                                </div>
                            </Carousel>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}